import { Navigate } from 'react-router-dom';
import { DashboardFormWrapper } from '../dashboard';
import { SalesFeesPage } from './SalesFeesComponents';
import { SalesFeesAddHeader, SalesFeesAddForm } from './SalesFeesAddComponents';
import { useStore } from '../../context';
import { showToRoles } from '../../utils';
import { RoleGuard } from '../../routes';

export const SalesFeesAdd = () => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER'], user))
    return <Navigate to={`/sales-fees/view/${user.yardEmployee.yardId}`} replace />;

  return (
    <RoleGuard roles={'admin'}>
      <SalesFeesPage>
        <SalesFeesAddHeader />
        <DashboardFormWrapper flow={'row'}>
          <SalesFeesAddForm />
          <SalesFeesAddHeader showOnlySubmit />
        </DashboardFormWrapper>
      </SalesFeesPage>
    </RoleGuard>
  );
};
